import { Helmet } from "react-helmet";
import { IS_SNAP, IS_PRODUCTION, getEnvVar } from "../utils/envVar";

const LINKEDIN_INSIGHT_TAG = getEnvVar('REACT_APP_LINKEDIN_INSIGHT_TAG')

const LinkedInInsight = () => {
  if (!IS_PRODUCTION || IS_SNAP || !LINKEDIN_INSIGHT_TAG) return null;

  return (
    <Helmet>
      <script type="text/javascript" async src="https://snap.licdn.com/li.lms-analytics/insight.min.js"></script>
      <script type="text/javascript">
        {`
        _linkedin_partner_id = "${LINKEDIN_INSIGHT_TAG}";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      `}
      </script>
      <noscript>
        {`
        <img height="1" width="1" style="display:none;" alt=""
        src="https://px.ads.linkedin.com/collect/?pid=${LINKEDIN_INSIGHT_TAG}&fmt=gif" />
      `}
      </noscript>
    </Helmet>
  )
};

export default LinkedInInsight;
